import ApiClient from '@afosto/api/ApiClient';

class Conversations {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Add a message
   *
   * @param {Number} id
   * @param {Object} body - The new message
   * @param {Object} options - The additional request options
   * @description Append a message to the conversation
   * @returns {Promise}
   */
  addMessage(id, body, options = {}) {
    return this.apiClient.request({
      url: `/mes/conversations/${id}/messages`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Add a participant
   *
   * @param {Number} id
   * @param {Object} body - The new message
   * @param {Object} options - The additional request options
   * @description Register a new participant in the conversation
   * @returns {Promise}
   */
  addRegistration(id, body, options = {}) {
    return this.apiClient.request({
      url: `/mes/conversations/${id}/register`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * View a conversation
   *
   * @param {Number} id
   * @param {Object} options - The additional request options
   * @description Retrieve a single conversation
   * @returns {Promise}
   */
  getConversation(id, options = {}) {
    return this.apiClient.request({
      url: `/mes/conversations/${id}`,
      method: 'get',
      ...options,
    });
  }

  /**
   * List conversations
   *
   * @param {Object} options - The additional request options
   * @description Returns a list of conversations
   * @returns {Promise}
   */
  listConversations(options = {}) {
    return this.apiClient.request({
      url: `/mes/conversations`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Search for conversations
   *
   * @param {Object} body - Search query object
   * @param {Object} options - The additional request options
   * @description Run a complex search to find conversations
   * @returns {Promise}
   */
  searchConversations(body, options = {}) {
    return this.apiClient.request({
      url: `/mes/conversations/search`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Start a conversations conversation
   *
   * @param {Object} body - Conversation object
   * @param {Object} options - The additional request options
   * @description Instantiate a conversation
   * @returns {Promise}
   */
  startConversation(body, options = {}) {
    return this.apiClient.request({
      url: `/mes/conversations`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Add a subscription
   *
   * @param {Number} id
   * @param {Object} body - The subscription data
   * @param {Object} options - The additional request options
   * @description Add a subscription to recieve updates on this conversation
   * @returns {Promise}
   */
  subscribe(id, body, options = {}) {
    return this.apiClient.request({
      url: `/mes/conversations/${id}/subscribe`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Cancel a subscription
   *
   * @param {Number} id
   * @param {Object} body - The subscription data
   * @param {Object} options - The additional request options
   * @description Remove a subscription to recieve updates on this conversation
   * @returns {Promise}
   */
  unsubscribe(id, body, options = {}) {
    return this.apiClient.request({
      url: `/mes/conversations/${id}/unsubscribe`,
      method: 'post',
      data: body,
      ...options,
    });
  }
}

export const conversations = new Conversations();

export default Conversations;
